export default "__VITE_ASSET__BjXvZ920__"